import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaTwitter, FaGithub, FaEnvelope, FaPhone } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: 'Technical SEO', path: '/services#technical' },
      { name: 'On-Page Optimization', path: '/services#onpage' },
      { name: 'Link Building', path: '/services#linkbuilding' },
      { name: 'Content Strategy', path: '/services#content' },
    ],
    resources: [
      { name: 'SEO Blog', path: '/blog' },
      { name: 'Free Tools', path: '/resources' },
      { name: 'Case Studies', path: '/portfolio' },
      { name: 'ROI Calculator', path: '/resources#calculator' },
    ],
    company: [
      { name: 'About', path: '/about' },
      { name: 'Portfolio', path: '/portfolio' },
      { name: 'Results', path: '/results' },
      { name: 'Contact', path: '/contact' },
    ],
  };

  const socialLinks = [
    { icon: FaLinkedin, href: 'https://linkedin.com/in/utkrsh-sharma', label: 'LinkedIn' },
    { icon: FaTwitter, href: 'https://twitter.com/utkrsh', label: 'Twitter' },
    { icon: FaGithub, href: 'https://github.com/utkrsh', label: 'GitHub' },
  ];

  return (
    <footer className="bg-dark text-white">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8 sm:mb-12">
          {/* Brand Section */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4 sm:mb-6">
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-primary rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg sm:text-xl">S</span>
              </div>
              <span className="text-lg sm:text-xl font-bold">SEOExpert</span>
            </div>
            <p className="text-sm sm:text-base text-gray-300 mb-4 sm:mb-6 leading-relaxed">
              Results-driven Digital Marketing Executive helping Delhi NCR businesses achieve sustainable 
              organic growth through data-driven strategies and proven methodologies.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-700 rounded-lg flex items-center justify-center hover:bg-primary transition-colors duration-300 touch-friendly"
                  aria-label={social.label}
                >
                  <social.icon className="w-4 h-4 sm:w-5 sm:h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Services</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <FaEnvelope className="text-primary" />
                <a
                  href="mailto:maheshsharma4651@gmail.com"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  maheshsharma4651@gmail.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <FaPhone className="text-primary" />
                <a
                  href="tel:+919897785402"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  +91-9897785402
                </a>
              </div>
            </div>
            
            <div className="mt-8">
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © {currentYear} SEOExpert. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 